var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MachineWiseChart',{ref:"chart",attrs:{"unit":_vm.unit,"scale":_vm.scale,"loading":_vm.loading,"title":"Last 7 Days (MINS)","daterange":_vm.daterange}})
}
var staticRenderFns = []

export { render, staticRenderFns }